/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.4"
				d="M14.9358 10.1938C15.6485 10.8174 16.0048 11.1292 16.1358 11.4987C16.2509 11.823 16.2509 12.177 16.1358 12.5013C16.0048 12.8708 15.6485 13.1826 14.9358 13.8062L12.9804 15.5171C11.7162 16.6233 11.0841 17.1765 10.5479 17.1936C10.082 17.2085 9.63573 17.0059 9.34017 16.6455C9 16.2308 9 15.3908 9 13.711L9 10.289C9 8.60917 9 7.76923 9.34017 7.35445C9.63573 6.99405 10.082 6.79153 10.5479 6.80642C11.0841 6.82355 11.7162 7.37665 12.9804 8.48286L14.9358 10.1938Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10ZM14.9358 10.1938C15.6485 10.8174 16.0048 11.1292 16.1358 11.4987C16.2509 11.823 16.2509 12.177 16.1358 12.5013C16.0048 12.8708 15.6485 13.1826 14.9358 13.8062L12.9804 15.5171C11.7162 16.6233 11.0841 17.1765 10.5479 17.1936C10.082 17.2085 9.63573 17.0059 9.34017 16.6455C9 16.2308 9 15.3908 9 13.711V10.289C9 8.60917 9 7.76923 9.34017 7.35445C9.63574 6.99405 10.082 6.79153 10.5479 6.80642C11.0841 6.82355 11.7162 7.37665 12.9804 8.48286L14.9358 10.1938Z"
				fill="currentColor"
			/>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.9358 10.1938C15.6485 10.8174 16.0048 11.1292 16.1358 11.4987C16.2509 11.823 16.2509 12.177 16.1358 12.5013C16.0048 12.8708 15.6485 13.1826 14.9358 13.8062L12.9804 15.5171C11.7162 16.6233 11.0841 17.1765 10.5479 17.1936C10.082 17.2085 9.63573 17.0059 9.34017 16.6455C9 16.2308 9 15.3908 9 13.711L9 10.289C9 8.60917 9 7.76923 9.34017 7.35445C9.63573 6.99405 10.082 6.79153 10.5479 6.80642C11.0841 6.82355 11.7162 7.37665 12.9804 8.48286L14.9358 10.1938Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM15.3053 11.5365C15.194 11.194 14.897 10.897 14.3029 10.303L13.0971 9.09708C11.8119 7.81195 11.1694 7.16939 10.6177 7.12597C10.139 7.0883 9.67123 7.28206 9.35939 7.64717C9 8.06797 9 8.97669 9 10.7941V13.2059C9 15.0234 9 15.9321 9.35939 16.3529C9.67123 16.718 10.139 16.9118 10.6177 16.8741C11.1694 16.8307 11.8119 16.1881 13.0971 14.903L14.3029 13.6971L14.303 13.6971C14.897 13.1031 15.194 12.806 15.3053 12.4636C15.4032 12.1623 15.4032 11.8378 15.3053 11.5365Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 14.5L2 15V15C2 16.8613 2 17.7919 2.24472 18.5451C2.73931 20.0673 3.93273 21.2607 5.45491 21.7553C6.20808 22 7.13872 22 9 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2L9 2C7.13872 2 6.20808 2 5.45491 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9V9L2 9.5M12.9804 8.48286L14.9358 10.1938C15.6485 10.8174 16.0048 11.1292 16.1358 11.4987C16.2509 11.823 16.2509 12.177 16.1358 12.5013C16.0048 12.8708 15.6485 13.1826 14.9358 13.8062L12.9804 15.5171C11.7162 16.6233 11.0841 17.1765 10.5479 17.1936C10.082 17.2085 9.63573 17.0059 9.34017 16.6455C9 16.2308 9 15.3908 9 13.711L9 10.289C9 8.60917 9 7.76923 9.34017 7.35445C9.63573 6.99405 10.082 6.79153 10.5479 6.80642C11.0841 6.82355 11.7162 7.37665 12.9804 8.48286Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.9358 10.1938C15.6485 10.8174 16.0048 11.1292 16.1358 11.4987C16.2509 11.823 16.2509 12.177 16.1358 12.5013C16.0048 12.8708 15.6485 13.1826 14.9358 13.8062L12.9804 15.5171C11.7162 16.6233 11.0841 17.1765 10.5479 17.1936C10.082 17.2085 9.63573 17.0059 9.34017 16.6455C9 16.2308 9 15.3908 9 13.711L9 10.289C9 8.60917 9 7.76923 9.34017 7.35445C9.63573 6.99405 10.082 6.79153 10.5479 6.80642C11.0841 6.82355 11.7162 7.37665 12.9804 8.48286L14.9358 10.1938Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				d="M14.3029 10.303C14.897 10.897 15.194 11.194 15.3053 11.5365C15.4032 11.8378 15.4032 12.1623 15.3053 12.4636C15.194 12.806 14.897 13.1031 14.3029 13.6971L13.0971 14.903C11.8119 16.1881 11.1694 16.8307 10.6177 16.8741C10.139 16.9118 9.67123 16.718 9.35939 16.3529C9 15.9321 9 15.0234 9 13.2059L9 10.7941C9 8.97669 9 8.06797 9.35939 7.64717C9.67123 7.28206 10.139 7.0883 10.6177 7.12597C11.1694 7.16939 11.8119 7.81195 13.0971 9.09708L14.3029 10.303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
